import { render, staticRenderFns } from "./Integracoes.vue?vue&type=template&id=a2d30a5c&scoped=true"
import script from "./Integracoes.vue?vue&type=script&lang=js"
export * from "./Integracoes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2d30a5c",
  null
  
)

export default component.exports